import React, { useState, useEffect, useContext, useRef } from "react";
import { CurrentUserContext } from '../../../context/CurrentUserContext.js';
import { useParams, useNavigate } from "react-router-dom";
import { levelContentData, videoBaseUrl } from "../LevelContentData";
import { videoTitle } from "../../../utils/videotitle";
import { slugify, slugToText, deslugifyTitle } from "../../../utils/slugify";
import { slugAlias } from "../../../utils/slugAlias.js";
import "./VideosHome.css"; 
import { TreeNode } from "../../MindMap/MindMap.jsx";
/* import "../../MindMap/MindMap.css"; */
import { Link } from "react-router-dom" ;
import VideoPlayer from "../../VideoPlayer/VideoPlayer";
import {countryToLang } from "../../../utils/languageMap.js";
import { getAccessibleLevels } from "../../../utils/accessibleLevels.js";
import { useTranslation } from "../../../utils/hooks/translateHook.js";  
import { useLevelContentData } from "../../../utils/hooks/translateLevelContentDataHook.js";
import { transformLevelContent } from "../../../utils/transformLevelContent.js";



export const API_URL = window.location.hostname === "localhost"
  ? "http://localhost:4000/api"
  : process.env.REACT_APP_API_URL //"http://academy-backend-env.eba-qassrxas.eu-north-1.elasticbeanstalk.com/api";

const CLOUDFRONT_DOMAIN = "vixacademy.com/videos"  //"d2ytlht1oeujr4.cloudfront.net";

/* console.log("Fetching videos from:", `${API_URL}/videos`);  */

const VideosHome = ({ user, subject }) => {
  const {currentUser , setCurrentUser, notesUpdated, setNotesUpdated} = useContext(CurrentUserContext);
  const [openTreeIndex, setOpenTreeIndex] = useState(null);
  const [selectedLevel, setSelectedLevel] = useState(null);
  const [openSubjectIndex, setOpenSubjectIndex] = useState(null);
  const [note, setNote] = useState("");
  const [signedVideoUrl, setSignedVideoUrl] = useState(null);
  const saveTimeout = useRef(null);

  const t = useTranslation();
  const translatedLevelContentData = useLevelContentData();
  const transformedData = transformLevelContent(translatedLevelContentData)

  const navigate = useNavigate(); 

  //const accessibleLevels = getAccessibleLevels(user);

  const accessibleLevels = transformedData
  .filter(item => user.subscriptionLevel >= item.level && item.level !== 9999)
  .sort((a, b) => a.level - b.level);

  const levelInfo = currentUser?.subscriptionLevel
  ? transformedData.find(item => item.level === currentUser.subscriptionLevel)
  : null;
  const levelTitle = levelInfo?.title || 'Unknown';


  const { videoSlug } = useParams();
  const realSlug = slugAlias[videoSlug] || videoSlug; 
  const userLevel = user.subscriptionLevel;
  const levelData = transformedData.find((level) => level.level === userLevel);
  const subjects = levelData?.subjects || [];
  const [lang2Letter, setLang2Letter] = useState("en");


  const getLangByCountry = (countryValue) => {
    if (!countryValue) return "en";
    return countryToLang[countryValue.toUpperCase()] || "en";
  };

  useEffect(() => {
    if (user?.country) {
      const code = user.country.toUpperCase()
      const defaultLang = getLangByCountry(code);
      console.log("🌎 Country:", user.country, "→ Default lang:", defaultLang);
      setLang2Letter(defaultLang);
    }
  }, [user?.country]);

  //the useEffect that provides order for the level of the users
useEffect(() => {
  if (!realSlug || !user?.subscriptionLevel || !transformedData.length) {
    return;
  }

  const slugText = videoSlug; // dependecy dahil kaldirabiliriz
  const userLevel = user.subscriptionLevel;

  const extractPrefix = (str) => {
    const match = str.match(/^(\d+)[\.-](\d+)[\.-](\d+)/);
    return match ? `${match[1]}.${match[2]}.${match[3]}` : null;
  };

  const slugPrefix = realSlug.split("-").slice(0, 3).join(".");
  /* console.log("🔍 Target prefix to match:", slugPrefix); */

  let requiredLevel = null;

  // Flatten all videos into a list
  const allVideos = transformedData.flatMap(level =>
    (level.videos || []).flatMap(group =>
      (group.list || []).map(video => ({
        level: level.level,
        title: typeof video === "string" ? video : video.title
      }))
    )
  );

  // Find matching video by prefix
  const matched = allVideos.find(video => {
    const videoPrefix = extractPrefix(video.title);
    return videoPrefix && videoPrefix === slugPrefix;
  });

  if (matched) {
    requiredLevel = matched.level;
    console.log(`✅ Match found ➤ Title: ${matched.title} | Level: ${requiredLevel}`);
  }

  console.log("🎯 Matched video:", matched?.title || "none", "| Required level:", requiredLevel, "| User level:", userLevel);

  if (requiredLevel && userLevel < requiredLevel) {
    console.warn("🚫 Access denied: video beyond user level");
    navigate("/upgrade");
  }
}, [videoSlug, user?.subscriptionLevel, transformedData]);




  useEffect(() => {
    console.log("running useEffect for video URL setup", realSlug, currentUser);
    if (!realSlug || !currentUser) return;

    const isLocal = window.location.hostname === "localhost";
    const fallbackUrl = `${videoBaseUrl}${realSlug}/master.m3u8`;

    if (isLocal) {
      //console.log("Localhost detected → Using offline video:", fallbackUrl);
      setSignedVideoUrl(fallbackUrl);
      return;
    }
    fetch(`${API_URL}/video-url/${realSlug}?_=${Date.now()}`, {  // Only run this fetch if NOT localhost
      method: "GET",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
      credentials: "include",
    })
      .then((res) => {
          if (res.status === 403) {
            navigate("/upgrade");
            return Promise.reject("Access denied");
          }
          if (!res.ok) {
            return Promise.reject("Request failed");
          }
          return res.json();
        })
      .then((data) => {
        const cloudUrl = `https://${CLOUDFRONT_DOMAIN}/${realSlug}/master.m3u8`;
        const finalUrl = data.signedUrl || cloudUrl;      //data.signedUrl  will be undefined/null if not allowed also starts null then gets the url-good for singular files 
        //console.log("✅ Using signed or fallback cloud URL:", finalUrl);
        setSignedVideoUrl(finalUrl);
      })
      .catch((err) => {
        //console.warn("⚠️ Fetch error → fallback to local video:", fallbackUrl);
        setSignedVideoUrl(fallbackUrl);
      });
  }, [realSlug, currentUser]);

  /*   const videoUrl = `${API_URL}/video-url/${realSlug}`; */   
  //for showing present notes
  useEffect(() => {
    if (!realSlug || !user) return;

    fetch(`${API_URL}/notes/${realSlug}?_=${Date.now()}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("No note found");
        return res.json();
      })
      .then((data) => {
        if (data && data.content) {
          setNote(data.content);
        } else {
          setNote("");
        }
      })
      .catch((err) => {
        console.log("An Error Occured:", err)
      });
  }, [realSlug, user, notesUpdated]);

  useEffect(() => {
    if (!note || !realSlug || !user) return;
    clearTimeout(saveTimeout.current);

    saveTimeout.current = setTimeout(() => {
      fetch(`${API_URL}/notes/${realSlug}?_=${Date.now()}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: JSON.stringify({ content: note })
      }).then(res => {
        if (res.ok) {
          console.log("💾 Auto-saved");
          setNotesUpdated(prev => prev + 1);
        }
      }).catch(console.error);
    }, 25000); 
  }, [note, realSlug, user]);

  const handleSaveNote = () => {
    fetch(`${API_URL}/notes/${realSlug}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({ content: note })
    })
    .then(res => res.json())
    .then(() => {
      setNotesUpdated(prev => prev +1);  
      alert('Note saved!');
    });
  };

  const handleDownloadNote = () => {
    const element = document.createElement("a");
    const file = new Blob([note], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = `${slugToText(videoSlug)}-note.txt`;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  //console.log("accesibledata", accessibleLevels)
  return (
    <div className="layout">
      <div className="video-page">
        <div className="video-content">
          {/* Sidebar */}
          <aside className="sidebar">
            <div className="user-profile">
              <img className="profile-pic" src={currentUser.profilePicture} />
              <h3>{t('greeting')} {currentUser?.name} !</h3>
            </div>
            {/*Sidebar Lessons Tree under*/}
            <div className="map-container">
              {accessibleLevels.flatMap(level => level.subjects || []).map((subject, idx) => (
                <details key={idx} className="subject-accordion" open={openSubjectIndex=== idx}
                onClick={(e) => {
                  e.preventDefault();
                  setOpenSubjectIndex(openSubjectIndex === idx ? null : idx);
                }}
                >
                  <summary className="videoSubject-title">{(subject.title).toUpperCase()}</summary>

                  {Array.isArray(subject.videos) && subject.videos.length > 0 && (
                    <ul className="video-list">
                      {subject.videos.map((filename, vidIdx) => (
                        <li key={vidIdx}>
                        <Link to={`/videos/${slugify(filename)}`}> 
                            {videoTitle(filename).replace(/^\d+(\.\d+)*\.\s*/, '').toUpperCase()}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </details>
              ))}
            </div>

          </aside>

          {/* Main Content */}
          <main className="video-main">
            {user && videoSlug && signedVideoUrl && (
              <div className="video-box">
                {/* <h2 className="video-title">{slugToText(videoSlug)}</h2> */}
                <VideoPlayer
                  key={signedVideoUrl}  //signedVideoUrl
                  videoUrl={signedVideoUrl} // signedVideoUrl
                  country={user?.country}           
                />
              </div>
            )}

            <div className="notes-section">
             {/*  <p><strong>Video Name: </strong> {slugToText(videoSlug)}</p> */}
              <p>
                <strong>{t('lessonName')} </strong>
                {videoTitle(videoSlug)
                  .replace(/^(\d+)\s(\d+)\s(\d+)/, '$1.$2.$3')
                  .toUpperCase()}
              </p>
              <div className="note-layout">
                <div className="note-buttons">
                  <button className="save-button" onClick={handleSaveNote}>{t('save')}</button>
                  <button className="download-button" onClick={handleDownloadNote}>{t('download')}</button>
                </div>
                <textarea 
                  className="note-input"
                  placeholder="Write your notes here..."
                  value={note}
                  onChange={(e) => setNote(e.target.value)}
                />
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default VideosHome;
